import React from 'react';

import { TitleWithDescription, Radio, RadioGroup } from '@infoods/lifebase-ui';

import classes from './SelectPaymentMethod.module.scss';
import {
  PaymentMethodType,
  PAYMENT_METHODS,
} from '../NgzSelfBillingFailedPayment.settings';
import { SelectableCard } from '../../../../../shared/components/form-components';

type SelectPaymentMethodProps = {
  paymentMethod: PaymentMethodType;
  setPaymentMethod: (paymentMethod: PaymentMethodType) => void;
};

const SelectPaymentMethod = ({
  paymentMethod,
  setPaymentMethod,
}: SelectPaymentMethodProps) => {
  return (
    <RadioGroup
      value={paymentMethod}
      className={classes.selectPaymentMethod}
      onChange={(e, value) => {
        setPaymentMethod(value as PaymentMethodType);
      }}
    >
      <SelectableCard variant="inBox" className={classes.card}>
        <Radio value={PAYMENT_METHODS.NEW_CARD} />
        <TitleWithDescription
          title="Use a New Card"
          description="Enter a new payment method to complete your transaction"
          titleFont="title-16-bold"
        />
      </SelectableCard>
      <SelectableCard variant="inBox" className={classes.card}>
        <Radio value={PAYMENT_METHODS.RETRY_WITH_CURRENT_CARD} />
        <TitleWithDescription
          title="Retry with Current Card"
          description="Try processing the payment again using your saved card"
          titleFont="title-16-bold"
        />
      </SelectableCard>
    </RadioGroup>
  );
};

export { SelectPaymentMethod };
